module.exports = "/_next/static/images/ug-c94bc7a829368e5d82b164aef91eb627.svg";